document.addEventListener('DOMContentLoaded', function() {
  const uploadInput = document.getElementById('design-upload');
  const fileNameDisplay = document.getElementById('file-name-display');
  const overlayContainer = document.getElementById('overlay-container');
  const uploadedOverlay = document.getElementById('uploaded-overlay');
  const canvasWrapper = document.getElementById('canvas-wrapper');
  const resetButton = document.getElementById('reset-button');

  if (!uploadInput || !overlayContainer) return;

  // Render Uploaded File to Canvas
  uploadInput.addEventListener('change', function(e) {
    const file = e.target.files[0];
    if (file) {
      fileNameDisplay.textContent = file.name;
      const reader = new FileReader();
      reader.onload = function(event) {
        uploadedOverlay.src = event.target.result;
        overlayContainer.classList.remove('hidden');
        resetButton.classList.remove('hidden');
        
        // Center image upon arrival
        overlayContainer.style.top = '25%';
        overlayContainer.style.left = '25%';
        overlayContainer.style.width = '40%';
      };
      reader.readAsDataURL(file);
    }
  });

  // Remove Graphic Clean-up
  resetButton.addEventListener('click', function() {
    uploadInput.value = '';
    fileNameDisplay.textContent = 'No file selected';
    overlayContainer.classList.add('hidden');
    resetButton.classList.add('hidden');
    uploadedOverlay.src = '';
  });

  // Track Positions and Drag States
  let isDragging = false;
  let isResizing = false;
  let currentHandle = null;
  let startX, startY, startLeft, startTop, startWidth;

  overlayContainer.addEventListener('pointerdown', function(e) {
    if (e.target.classList.contains('resize-handle')) {
      isResizing = true;
      currentHandle = e.target;
    } else {
      isDragging = true;
    }
    
    startX = e.clientX;
    startY = e.clientY;
    startLeft = overlayContainer.offsetLeft;
    startTop = overlayContainer.offsetTop;
    startWidth = overlayContainer.offsetWidth;
    
    overlayContainer.setPointerCapture(e.pointerId);
    e.stopPropagation();
    e.preventDefault();
  });

  overlayContainer.addEventListener('pointermove', function(e) {
    if (!isDragging && !isResizing) return;

    const deltaX = e.clientX - startX;
    const deltaY = e.clientY - startY;
    const canvasRect = canvasWrapper.getBoundingClientRect();

    if (isDragging) {
      let newLeft = startLeft + deltaX;
      let newTop = startTop + deltaY;

      // Keep graphic inside the canvas boundaries
      newLeft = Math.max(0, Math.min(newLeft, canvasRect.width - overlayContainer.offsetWidth));
      newTop = Math.max(0, Math.min(newTop, canvasRect.height - overlayContainer.offsetHeight));

      overlayContainer.style.left = `${(newLeft / canvasRect.width) * 100}%`;
      overlayContainer.style.top = `${(newTop / canvasRect.height) * 100}%`;
    } 
    else if (isResizing) {
      let newWidth = startWidth;

      if (currentHandle.classList.contains('bottom-right') || currentHandle.classList.contains('top-right')) {
        newWidth = startWidth + deltaX;
      } else {
        newWidth = startWidth - deltaX;
      }

      // Enforce file size boundaries
      if (newWidth > 40 && newWidth < canvasRect.width) {
        overlayContainer.style.width = `${(newWidth / canvasRect.width) * 100}%`;
      }
    }
  });

  const endInteraction = function(e) {
    if (!isDragging && !isResizing) return;
    isDragging = false;
    isResizing = false;
    currentHandle = null;
  };

  overlayContainer.addEventListener('pointerup', endInteraction);
  overlayContainer.addEventListener('pointercancel', endInteraction);
});
